module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', [_c('notifications', {
    staticClass: "position-absolute d-flex float-right w-100 global-notification",
    attrs: {
      "eventName": "mainNotif"
    }
  }), _vm._v(" "), (!_vm.isHidden) ? _c('document-main-view', {
    attrs: {
      "documents": _vm.documents
    }
  }) : _vm._e(), _vm._v(" "), (_vm.showUBO) ? _c('div', [_c('div', {
    style: (!_vm.isHidden ? 'padding: 0 15px 15px 15px;' : '')
  }, [(!_vm.isHidden) ? _c('button', {
    staticClass: "btn-declare",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.isHidden = !_vm.isHidden
      }
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('iframe_page.doctypes.complete_declaration')) + "\n      ")]) : _vm._e()]), _vm._v(" "), (_vm.isHidden) ? _c('document-ubo-view', {
    attrs: {
      "keys": _vm.reloadComponent,
      "ubos": _vm.ubos
    },
    on: {
      "update:parent": function($event) {
        _vm.isHidden = false
      }
    }
  }) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-5ef54cfa", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5ef54cfa","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/LMSGiframe/SendDocumentsFromApplicationForm.vue
// module id = 2430
// module chunks = 2